export const DailyRepetitionSelector = () => {
  return (
    <span className="block text-secondary-300 text-xs">
      The Task will be scheduled on every day
    </span>
  )
}
